import Component, { ComponentAttrs } from 'flarum/common/Component';
import Mithril from 'mithril';
import { ReputationProgressBarAttrs } from './types';
import app from 'flarum/forum/app';

export default class ReputationProgressBar extends Component<ReputationProgressBarAttrs> {
  oninit(vnode: Mithril.Vnode<ComponentAttrs, this>) {
    super.oninit(vnode);
  }

  onbeforeupdate(vnode: Mithril.Vnode<ReputationProgressBarAttrs, this>): boolean {
    return vnode.attrs.value !== this.attrs.value;
  }

  view(vnode: Mithril.Vnode<ComponentAttrs, this>): Mithril.Children {
    const gradientStyle: string = `radial-gradient(closest-side, #383838 79%, transparent 80% 100%), conic-gradient(#7fba00 ${this.attrs.value}%, #4d698e 0)`;
    return (
      <div className="progress-bar-container">
        <span class="progress-bar-text">{app.translator.trans('justoverclock-reputation-score.forum.trust')}</span>
        <div class="progress-bar" style={{ background: gradientStyle }}>
          <progress value={this.attrs.value} min="0" max="100" style="visibility:hidden;height:0;width:0;" />
        </div>
      </div>
    );
  }
}
